import {useCallback} from "preact/hooks";
import Cookies from "js-cookie";
import {api} from "../../services";

/**
 * Recovers from a region desync detected the moment the backend refuses
 * a cart mutation with `unit_region_mismatch` (PEC-509): the page state
 * (STORE_LOCATION cookie) diverged from the server session store — stale
 * tab, expired store cookie, external ?___store= link.
 *
 * Returns a stable callback that realigns the cookie to the server value
 * (lightweight fast path) and reloads once, so every region-dependent
 * view (product units, prices, cart) renders the server region. Writing
 * the cookie BEFORE the reload is what keeps it a single reload — the
 * boot sync in UserContext then finds cookie and server already matching.
 */
export default function useRegionSync() {
    return useCallback(async () => {
        try {
            const {data} = await api.get("/v1/data?fields=currentStore");
            const currentStore = data.currentStore;

            if (currentStore?.id) {
                Cookies.set("STORE_LOCATION", JSON.stringify({
                    id:   currentStore.id,
                    name: currentStore.name,
                }), {expires: 7});
            }
        } catch (error) {
            // Boot sync still realigns after the reload — worst case the
            // page reloads twice instead of once.
            console.error("Error while recovering region sync:", error);
        }

        window.location.reload();
    }, []);
}
